import 'bootstrap-sass/assets/javascripts/bootstrap/carousel';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import 'bootstrap-sass/assets/javascripts/bootstrap/transition';
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import 'owl.carousel/dist/owl.carousel.min';
import 'isotope-layout/dist/isotope.pkgd.min';
import 'isotope-packery/packery-mode.pkgd.min';
import 'imagesloaded/imagesloaded.pkgd.min';
import './jquery.tokeninput_modified';
import './jquery.touchSwipe.min';
import './jquery.sticky';
import mixitup from 'mixitup';


var gaOptout=function(){document.cookie=disableStr_ga+'=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';window[disableStr_ga]=!0;var message='Google Analytics was disabled';alert(message)};

console.log('[debug]', 'version 1')

var validateEmail = function (email) {
    // First check if any value was actually set
    if (email.length == 0) return false;
    // Now validate the email format using Regex
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    return re.test(email);
};

window.mobilecheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        check = true;
    }

    return check;
};
var isMobileDevice = window.mobilecheck();

Date.prototype.addDays = function(days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

var getVideoPortView = function() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    //return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
    return e[ a+'Width' ];
};

var elementInViewport = function(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    /*
      while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }
    */

    var elTopPlusHeight = (top + height);
    var $ = jQuery;
    if ($('#header.sticky').length > 0 && $('#header.sticky').closest('.is-sticky').length > 0) {
        elTopPlusHeight = elTopPlusHeight - $('#header.sticky').innerHeight();
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        elTopPlusHeight > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
};

var scrollToEl = function(target, bottom, subtract) {
    var isModalOpen = false;
    var scrollingEl = jQuery('html,body');
    if (jQuery('body').hasClass('modal-open')) {
        scrollingEl = jQuery('#modal');
        isModalOpen = true;
    }

    if (typeof subtract == 'undefined') {
        subtract = 0;
    }

    var scrollTopPosition = target.offset().top;
    if (typeof bottom != 'undefined' && bottom) {
        scrollTopPosition = scrollTopPosition + target.outerHeight();
    }
    scrollTopPosition = scrollTopPosition - jQuery('#header').outerHeight(true) - subtract;
    if (isModalOpen) {
        /*var modalOffset = scrollingEl.position().top;
        scrollTopPosition = scrollTopPosition - modalOffset;*/
        scrollTopPosition = target.position().top;
        //console.log('scrollTopPosition ', scrollTopPosition, ' modalOffset', modalOffset);
    }

    if (target.length > 0) {
        scrollingEl.animate({
            scrollTop: scrollTopPosition
        }, 1000);
    }
};

var animatedScrollFunction = function(el, e) {
    e.preventDefault();
    e.stopPropagation();

    var target = null;
    if (el.hasClass('js-scrollNextAreaContent')) {
        var current_pimcore_area_content = el.closest('.pimcore_area_content');
        var next_pimcore_area_content = current_pimcore_area_content.next('.pimcore_area_content');
        if (next_pimcore_area_content.length > 0) {
            next_pimcore_area_content = jQuery(next_pimcore_area_content[0]);
            target = next_pimcore_area_content;
        } else {
            next_pimcore_area_content = current_pimcore_area_content.next('.defaultareablockOuterDetailpage, .defaultareablockOuter');
            if (next_pimcore_area_content.length > 0) {
                next_pimcore_area_content = next_pimcore_area_content.find('.pimcore_area_content');

                if (next_pimcore_area_content.length > 0) {
                    next_pimcore_area_content = jQuery(next_pimcore_area_content[0]);
                    target = next_pimcore_area_content;
                }
            }
        }
    } else {
        var target = jQuery(''+el.attr('data-selector'));
    }


    if (target && target.length > 0) {
        scrollToEl(target);
        return false;
    }

    return false;
};


var setBodyClassWindowHeight = function() {
    var $ = jQuery;
    if( $('body').hasClass('editMode') ) {
        return;
    }

    var height = $(window).height();
    if (height < 500) {
        $('body').addClass('smallHeight');
    } else {
        $('body').removeClass('smallHeight');
    }
};

var setHeaderImageBoxHeight = function() {
    var $ = jQuery;
    if( $('body').hasClass('editMode') ) {
        return;
    }
    var headerCarousels = $('.headerCarousel');


    if (headerCarousels.length > 0) {

        var headerMinHeight = 135;

        jQuery.each(headerCarousels, function(){
            var headerCarousel = $(this);

            var windowHeight = $(window).height();

            var headerHeight = $('#header').outerHeight(true);
            if ($('#header').closest('.sticky-wrapper').length > 0) {
                var stickyPosition = $('#header').closest('.sticky-wrapper').css('position');
                if (stickyPosition == 'absolute') {
                    headerHeight = 0;
                }
            }

            var newHeaderImageBoxHeight = windowHeight - headerHeight;

            if (headerCarousel.hasClass('js-smallHeight')) {
                if ($('.defaultareablockOuterDetailpage .pimcore_area_content:first-child .titleBox').length > 0) {
                    newHeaderImageBoxHeight = newHeaderImageBoxHeight - $('.defaultareablockOuterDetailpage .pimcore_area_content:first-child .titleBox').outerHeight(true);
                    /*if (getVideoPortView() > 991) {
                        newHeaderImageBoxHeight = newHeaderImageBoxHeight - 105;
                    } else {
                        newHeaderImageBoxHeight = newHeaderImageBoxHeight - 85;
                    }*/

                } else {
                    newHeaderImageBoxHeight = newHeaderImageBoxHeight / 3 * 2;
                }
            }

            if (newHeaderImageBoxHeight < headerMinHeight) {
                newHeaderImageBoxHeight = headerMinHeight;
            }
            var headerItems = headerCarousel.find('.item');

            if (newHeaderImageBoxHeight < 380) {
                headerCarousel.addClass('resizeSmall');
            } else {
                headerCarousel.removeClass('resizeSmall');
            }

            jQuery.each(headerItems, function(){
                $(this).height(newHeaderImageBoxHeight);

                var theImage = $(this).find('img');
                var theYoutubeVideoContainer = $(this).find('.videoContainer');
                // contained image has the min-height?
                theImage.css('width', '100%');
                theImage.css('height', 'auto');
                theImage.css('margin-left', '0');
                var originalHeight = null;
                var originalWidth = null;
                if (true || theImage.height() < newHeaderImageBoxHeight) {
                    originalHeight = parseInt(theImage.attr('data-height'));
                    originalWidth = parseInt(theImage.attr('data-width'));
                    var newWidth = newHeaderImageBoxHeight * originalWidth / originalHeight;
                    var newHeight = newHeaderImageBoxHeight;
                    if (newWidth < $(window).width()) {
                        newWidth = $(window).width();
                        newHeight = newWidth * originalHeight / originalWidth;
                    }
                    theImage.css('width', newWidth+'px');
                    theImage.css('height', newHeight+'px');
                    // orizontally center
                    var marginleft = (newWidth - $(window).width()) / 2 * (-1);
                    theImage.css('margin-left', marginleft+'px');
                }

                // center the contained image
                var imgMarginTop = (newHeaderImageBoxHeight - theImage.height()) / 2;
                theImage.css('margin-top', imgMarginTop );


                //set youtube video height if any present
                if (theYoutubeVideoContainer.length > 0) {
                    theYoutubeVideoContainer.css('height',  newHeight+'px');
                }
            });
        });
    }

    var magazineHederImgBanner = $('.magazineDetailOuter .imgBannerOuter .imgBanner');
    if (magazineHederImgBanner.length > 0) {
        var headerMinHeight = 300;

        jQuery.each(magazineHederImgBanner,function(){
            var headerHeight = $('#header').outerHeight(true);
            if ($('#header').closest('.sticky-wrapper').length > 0) {
                var stickyPosition = $('#header').closest('.sticky-wrapper').css('position');
                if (stickyPosition == 'absolute') {
                    headerHeight = 0;
                }
            }

            var newHeaderImageBoxHeight = $(window).height() - headerHeight;
            newHeaderImageBoxHeight = newHeaderImageBoxHeight / 3 * 2;

            if (newHeaderImageBoxHeight < headerMinHeight) {
                newHeaderImageBoxHeight = headerMinHeight;
            }

            magazineHederImgBanner.height(newHeaderImageBoxHeight);
        })
    }
};

var setSwipeFunctionalityForBootstrapCarousel = function(carousels) {
    var $ = jQuery;

    jQuery.each(carousels, function() {
        var carousel = $(this);
        if (!carousel.hasClass('js-swipeDisabled')) {
            carousel.swipe({
                swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
                    if (direction == 'left') $(this).carousel('next');
                    if (direction == 'right') $(this).carousel('prev');
                },
                allowPageScroll:"vertical"
            });
        }
    })
};

jQuery.fn.shuffle = function() {

    var allElems = this.get(),
        getRandom = function(max) {
            return Math.floor(Math.random() * max);
        },
        shuffled = jQuery.map(allElems, function(){
            var random = getRandom(allElems.length),
                randEl = jQuery(allElems[random]).clone(true)[0];
            allElems.splice(random, 1);
            return randEl;
        });

    this.each(function(i){
        jQuery(this).replaceWith(jQuery(shuffled[i]));
    });

    return jQuery(shuffled);

};

/**
 * @param siblings {jQuery} List of sibling elements to act upon
 * @param subjectIndex {int} Index of the item to be moved
 * @param objectIndex {int} Index of the item to move subject after
 */
var swapElements = function(siblings, subjectIndex, objectIndex) {
    // Get subject jQuery
    var subject = jQuery(siblings.get(subjectIndex));
    // Get object element
    var object = siblings.get(objectIndex);
    // Insert subject after object
    subject.insertAfter(object);
};

// on init scroll to the
var scrollOnInit = function() {
    if (typeof window.location != 'undefined' && typeof window.location.hash != 'undefined' && window.location.hash != '') {
        var target = $(''+window.location.hash);
        if (target.length > 0) {
            /*if (target.closest('.pimcore_area_content').length > 0) {
                target = $(target.closest('.pimcore_area_content')[0]);
            }*/
            scrollToEl(target);
        }
    }
};


var initMain = (function ($) {
    console.log('[debug]', 'Main 1')
    $(function () {
        console.log('[debug]', 'Main 2')

        jQuery.fn.hasScrollBar = function() {
            return this.get(0).scrollHeight > this.height();
        };

        setTimeout(function(){
            scrollOnInit();
        }, 100);

        // header images carousel
        setHeaderImageBoxHeight();
        setBodyClassWindowHeight();
        $(window).on('load', function(){
            setHeaderImageBoxHeight();
            $('#header .logo2').removeAttr('style');
        });

        $(window).resize(function(){
            setHeaderImageBoxHeight();
            setBodyClassWindowHeight();

            setTimeout(function(){
                setHeaderImageBoxHeight();
                // $(".sticky").sticky('update');
            }, 100)
        });


// BASIC BEHAVIOUR ELEMENTS (could not be yet used in this project, but they are very common)
        /*$(document).on("click", ".js-link", function(e) {
            e.preventDefault();
            var link = $(this).attr('data-href');
            if (link != '') {
                window.location.href = link;
            }
        });*/

        $('.js-animatedScroll').on('click', function(e) {
            if (!$(this).hasClass('js-closeMobileMenu')) {
                animatedScrollFunction($(this), e);
            } else {
                var el = $(this);
                setTimeout(function(){
                    animatedScrollFunction(el, e);
                }, 500);
            }
        });

        var setScrollClasses = function() {
            if ($(window).scrollTop() == 0) {
                $('body').removeClass('notTopPosition');
            } else {
                $('body').addClass('notTopPosition');
            }
        }
        setScrollClasses();
        $(window).scroll(function(){
            setScrollClasses();

            setTimeout(function(){
                setHeaderImageBoxHeight();
                // $(".sticky").sticky('update');
            }, 100)
        });
// end BASIC BEHAVIOUR ELEMENTS

// SOME COMMON FUNCTIONS
        $('.headerCarousel').carousel({
            interval: 7000,
            pause: null,
        });
        $('.headerCarousel').carousel('cycle');

        // SWIPE for carousel
        var carousels = $(".carousel");
        setSwipeFunctionalityForBootstrapCarousel( carousels );


        $('#modal').on('hidden.bs.modal', function (e) {
            var modal = $('#modal');
            modal.removeClass('youtubeModal');
            modal.find('.modal-dialog').removeClass('modal-lg');
            modal.find('.modal-body').html(' ');
        });



        $(document).on('click', '.js-openCarouselInModal', function(){
            var carouselTemplateOuter = $(this).closest('.js-carouselTemplateOuter');
            if (carouselTemplateOuter.length == 0) {
                return;
            }
            var carouselTemplate = carouselTemplateOuter.find('.js-carouselTemplate');
            if (carouselTemplate.length == 0) {
                return;
            }
            carouselTemplate = carouselTemplate.attr('data-template');

            var modal = $('#modal');
            modal.addClass('youtubeModal');
            modal.modal('show');
            modal.find('.modal-dialog').addClass('modal-lg');
            modal.find('.modal-body').html( carouselTemplate );
            var newCarousel = modal.find('.modal-body').find('.carousel');
            newCarousel.carousel('cycle');
        });

        $(document).on('click', '.js-openPageInModal', function(e){
            e.preventDefault();
            var detailUrl = $(this).attr('href');
            if (typeof detailUrl == 'undefined') {
                detailUrl = $(this).attr('data-href');
            }

            e.preventDefault();

            var modal = $('#modal');
            modal.addClass('asFullPageOnMobile');
            modal.find('.modal-dialog').addClass('modal-lg');
            var modalBody = modal.find('.modal-body');
            modalBody.html('<div class="bigSpinnerContainer"><i class="fa fa-spinner fa-spin"></i></div>');
            modal.modal('show');

            jQuery.get(detailUrl, {'isAjax': 1}, function(data){
                modalBody.html( data );

                if (typeof initRangeSliderInput != 'undefined') {
                    initRangeSliderInput($('#modal .modal-body'));
                }
                if (typeof initializeMyDatepicker != 'undefined') {
                    initializeMyDatepicker($('#modal .modal-body'));
                }
                setTimeout(function(){
                    if(modal.find(".rangeSliderInput").length > 0) {
                        modal.find(".rangeSliderInput").slider('relayout');
                    }
                },500)
            });
        });

        $('a[data-scroll-to]').click(function(e){
            e.preventDefault();
            var target = $( '' + $(this).attr('data-scroll-to') );
            if (target.length == 0) {
                return;
            }

            scrollToEl( $(target[0]) );
        });


// end - SOME COMMON FUNCTIONS


        var equalHeightItems = function (owl, recalculate = true) {
            $(owl.target).find('.owl-item').each(function (index, item) {
                item.style.height = null;
                if (item.querySelector('.owl-item__image')) {
                    item.querySelector('.owl-item__image').style.height = null;
                }
            })
            var height= owl.target.querySelector('.owl-stage-outer').getBoundingClientRect().height;
            $(owl.target).find('.owl-item').each(function (index, item) {
                item.style.height = height + 'px';
                if ($(window).width() >= 1136) {
                    if (item.querySelector('.owl-item__image')) {
                        item.querySelector('.owl-item__image').style.height = height + 'px';
                    }
                }
            });

            if (recalculate) {
                setTimeout(() => {
                    equalHeightItems(owl, false);
                }, 5000);
            }
        }

        jQuery.each($(".owl-carousel:not(.owl-carousel--reference)"), function() {
            var owlCarousel = $(this);

            var options = {
                loop: false, // with this as true, is one only element is inserted, and itmes = 3 for example, then 3 cloned block will be displayed O.o
                margin: 30,
                nav: true,
                dots: true,
                stagePadding: 0,
                navText: ['<i class="svg-icon svg-angle-left svg-angle-left-dim" aria-hidden="true"></i>','<i class="svg-icon svg-angle-right svg-angle-right-dim" aria-hidden="true"></i>'],
                autoplay:true,
                autoplayHoverPause:true,
                autoplayTimeout: 6000,
                responsive:{
                    0:{
                        items: 1,
                        slideBy: 1
                    }
                },
                onChanged: function(event) {
                    /*var itemIndex = event.item.index;
                    if (itemIndex === null) {
                        return;
                    }
                    var carousel = event.target;
                    carousel = $(carousel);*/
                },

                onResize: function(owl) {
                },

                onResized: function(owl) {
                }
            };

            if(owlCarousel.hasClass('owl-partner')) {
                options['loop'] = true;
                options['dots'] = false;
                options['stagePadding'] = 30;
                options['margin'] = 60;
                options['responsive'] = {
                    0:{
                        items: 1,
                        slideBy: 1,
                        stagePadding: 30
                    },
                    758:{
                        items: 2,
                        slideBy: 1,
                        stagePadding: 30
                    },
                    991:{
                        items: 4,
                        slideBy: 1,
                        stagePadding: 30
                    },
                    1240:{
                        items: 4,
                        slideBy: 1,
                        margin: 90,
                        stagePadding: 30
                    }
                };
            }

            if(owlCarousel.hasClass('owl-service')) {
                options['navText'] = ['<i class="svg-icon svg-angle-left-white svg-angle-left-white-dim" aria-hidden="true"></i>','<i class="svg-icon svg-angle-right-white svg-angle-right-white-dim" aria-hidden="true"></i>'],
                    options['dots'] = false;
                options['stagePadding'] = 0;
                options['margin'] = 60;
                options['responsive'] = {
                    0:{
                        items: 1,
                        slideBy: 1
                    },
                    758:{
                        items: 2,
                        slideBy: 1
                    },
                    991:{
                        items: 3,
                        slideBy: 1
                    }
                };
            }


            if(owlCarousel.hasClass('owl-verticalboxareatemplate')) {
                options['dots'] = true;
                options['nav'] = false;
                // options['navText'] = ['<i class="svg-icon svg-angle-left-white svg-angle-left-white-dim" aria-hidden="true"></i>','<i class="svg-icon svg-angle-right-white svg-angle-right-white-dim" aria-hidden="true"></i>'],
                options['margin'] = 0;

                if (owlCarousel.hasClass('desktop')){
                    options['responsive'] = {
                        0:{
                            items: 4,
                            slideBy: 4
                        }
                    };
                } else {
                    options['responsive'] = {
                        0:{
                            items: 1,
                            slideBy: 1
                        },
                        758:{
                            items: 2,
                            slideBy: 1
                        }
                    };
                }
            }

            owlCarousel.owlCarousel(options);
        });

        var mixitListBox = $('.mixitListBox, .case-study-grid__list');
        if (mixitListBox.length > 0) {
            mixitup(mixitListBox, {
                selectors: {
                    target: '.mixitEl'
                },
                animation: {
                    duration: 300
                }
            });
        }


        // $(".sticky").sticky({topSpacing: 0, zIndex:999999});
        if (getVideoPortView() >= 768) {
            $(".js-stickyMagazineAuthor").sticky({topSpacing: 150, zIndex:999999});
        }

        $(window).resize(function(){
            // old... for author
            if (getVideoPortView() >= 768) {
                $(".js-stickyMagazineAuthor").sticky({topSpacing: 150, zIndex:999999});
            } else {
                $(".js-stickyMagazineAuthor").unstick();
            }

            // if (getVideoPortView() > 991) {
            //     $(".js-stickyMagazineAuthor").sticky({topSpacing: 150, zIndex:999999});
            // } else {
            //     $(".js-stickyMagazineAuthor").unstick();
            // }
        });

        //Burger Scroll Change Color
        var setStickyMagazineAuthorVisibility = function() {

            var fixed = $(".js-stickyMagazineAuthor")/*.closest('.sticky-wrapper.is-sticky')*/;
            if (fixed.length == 0) {
                return;
            }

            if (fixed.closest('.sticky-wrapper').length == 0) {
                fixed.removeClass('invisible');
                return;
            }

            var fixed_position = fixed.offset().top;
            var fixed_height = fixed.height();

            var underElement = null;
            var watchingElements = $(
                'body div.imgBannerOuter .imgBanner' + ', ' +
                'body .magazineRowList.visible-md .magazineEl' + ', ' +
                '.pimcore_area_magazine' + ', ' +
                '.contact-box__container' + ', ' +
                '.magazine__author' + ', ' +
                '.magazineDetailOuter .authorBoxExtended ' + ', ' +
                '#footer' + ', ' +
                'body .contactBox'
            );

            watchingElements.each(function(){
                var toCross_position = $(this).offset().top;
                var toCross_height = $(this).outerHeight();
                if ((fixed_position + fixed_height) >= toCross_position && (fixed_position) <= (toCross_position + toCross_height)) {
                    underElement = $(this);
                }
            });

            if (underElement) {
                fixed.addClass('invisible');
            } else {
                fixed.removeClass('invisible');
            }

        };

        setStickyMagazineAuthorVisibility();
        $(window).on('load', function(){
            setStickyMagazineAuthorVisibility();
        });


        $(window).scroll(function(){
            setStickyMagazineAuthorVisibility();
        });



        var setSiblingSwitcherColPosition = function() {
            if($('body').hasClass('editMode')){
                return;
            }

            jQuery.each($('.js-siblingSwitcher'),function(){

                var row = $(this);

                if (getVideoPortView() <= 991) {
                    var siblings = $([row.find('> [data-xs-pos="left"]'), row.find('> [data-xs-pos="right"]')]);
                    swapElements(siblings, 1, 0);
                } else {
                    var siblings = $([row.find('> [data-md-pos="left"]'), row.find('> [data-md-pos="right"]')]);
                    swapElements(siblings, 1, 0);
                    /// swapElements(siblings, 1, 0);
                }

                // is teaser area with hover box
                if (row.closest('.pimcore_area_content.pimcore_area_teaser').length > 0 && row.closest('.teaserEl').length > 0 && row.closest('.teaserEl').find('.hoverBox').length > 0) {
                    var hoverBox = row.closest('.teaserEl').find('.hoverBox');
                    var containerFluid = row.closest('.teaserEl').find('> .container-fluid');

                    if (getVideoPortView() <= 991) {
                        hoverBox.insertAfter( $(row.find('div[data-md-pos]')[0]) );
                    } else {
                        hoverBox.insertAfter( containerFluid );
                    }
                }

            });
        };
        setSiblingSwitcherColPosition();

        $(window).resize(function(){
            setSiblingSwitcherColPosition();
        });
    })

    if (
        ($('.pimcore_area_content').length == 0) ||
        ( $('.pimcore_area_content').length > 0 && ! $($('.pimcore_area_content')[0]).hasClass('pimcore_area_header') )
    ) {
        $('body').addClass('withoutHeader');
    }

    /*
    jQuery.getScript( "//www.youtube.com/iframe_api", function( data, textStatus, jqxhr ) {});
    */

    var areaContentCounter = 0;
    jQuery.each($('.pimcore_area_content'), function() {
        var areacontent = $(this);
        areacontent.attr('id', 'area_'+areaContentCounter);

        if (areacontent.hasClass('pimcore_area_teaser')) {
            var imgCol = areacontent.find('.imgCol');
            if (imgCol.length > 0) {
                imgCol.attr('id', 'area_'+areaContentCounter+'_imgcol');
            }
        }

        areaContentCounter++;
    });

    // validate form before submit
    $('form.contact').submit(function(e){
        e.preventDefault();
        var form = $(this);
        var url = $(this).attr('action');
        form.find('.js-error').remove();


        var hasError = false;
        var domElementError = null;
        var requiredField_inputs = form.find('select[required], input[required], textarea[required]');
        // inputs
        jQuery.each(requiredField_inputs, function(){
            var currentVal = $(this).val();
            var type = $(this).attr('type');

            var refElementErrorClass = $(this);
            if (type == 'checkbox' && $(this).closest('.checkbox').length > 0) {
                refElementErrorClass = $(this).closest('.checkbox');
            } else if ($(this).closest('.form-group').length > 0) {
                refElementErrorClass = $(this).closest('.form-group');
            }

            if (type == 'checkbox') {
                if ($(this).is(':checked')) {
                    refElementErrorClass.removeClass('error');
                } else {
                    refElementErrorClass.addClass('error');
                    if (domElementError == null) {
                        domElementError = refElementErrorClass;
                    }
                    hasError = true;
                }
            } else {
                if (currentVal == '') {
                    refElementErrorClass.addClass('error');
                    if (domElementError == null) {
                        domElementError = refElementErrorClass;
                    }
                    hasError = true;

                    //refElementErrorClass.find('.col-xs-12').append('<span class="js-error">'+application.tr.mandatory_field+'</span>');
                } else {
                    refElementErrorClass.removeClass('error');
                }
            }
        });

        if (hasError) {
            if (domElementError != null) {
                scrollToEl( domElementError );
            }
            return false;
        }

        //check if EMAIL is a valid value
        var emailInput = form.find('input[name="email"]');
        var emailInputBox = emailInput.closest('.form-group');
        if ( !validateEmail( emailInput.val()) ) {
            emailInputBox.addClass('error');
            if (domElementError == null) {
                domElementError = emailInputBox;
            }
            if (domElementError != null) {
                scrollToEl( domElementError );
            }
            //emailInputBox.find('.col-xs-12').append('<span class="js-error">'+application.tr.email_not_valid+'</span>');

            return false;
        } else {
            emailInputBox.removeClass('error');
        }

        if (hasError) {
            if (domElementError != null) {
                scrollToEl( domElementError );
            }
            return false;
        }

        ///////// valid, send
        var submitBtn = form.find('button[type="submit"]');
        submitBtn.attr('disabled', 'disabled');
        //submitBtn.html( '<i class="fa fa-spinner fa-spin"></i>' + submitBtn.html() );

        var data = form.serialize();

        jQuery.post(url, data, function(response){
            if(response.success) {
                form.html('<p class="bg-success" style="padding: 12px 20px;">'+response.message+'</p>');
                scrollToEl( form.find('p.bg-success') );
            }
        })

        return false;
    });

    var isOnMessageSet = false;

    jQuery.each($('.newsletterForm input[name="hs_context"]'), function(){
        $(this).val( $(this).attr('data-data') );
    });


    $('.newsletterForm').submit(function(){
        var form = $(this);
        form.find('p.bg-error').remove();

        var url = form.attr('action');

        var data = form.serializeArray();
        var datasubmit = new FormData();
        for (var i = 0; i<data.length; i++) {
            datasubmit.append(data[i].name, data[i].value);
        }

        var submitBtn = form.find('button[type="submit"]');
        submitBtn.attr('disabled', 'disabled');


        // VALIDATE REQUIRED
        var hasError = false;
        var domElementError = null;
        var requiredField_inputs = form.find('select[required], input[required], textarea[required]');
        // inputs
        jQuery.each(requiredField_inputs, function(){
            var currentVal = $(this).val();
            var type = $(this).attr('type');

            var refElementErrorClass = $(this);
            if (type == 'checkbox' && $(this).closest('.checkbox').length > 0) {
                refElementErrorClass = $(this).closest('.checkbox');
            } else if ($(this).closest('.form-group').length > 0) {
                refElementErrorClass = $(this).closest('.form-group');
            }

            if (type == 'checkbox') {
                if ($(this).is(':checked')) {
                    refElementErrorClass.removeClass('error');
                } else {
                    refElementErrorClass.addClass('error');
                    if (domElementError == null) {
                        domElementError = refElementErrorClass;
                    }
                    hasError = true;
                }
            } else {
                if (currentVal == '') {
                    refElementErrorClass.addClass('error');
                    if (domElementError == null) {
                        domElementError = refElementErrorClass;
                    }
                    hasError = true;

                    //refElementErrorClass.find('.col-xs-12').append('<span class="js-error">'+application.tr.mandatory_field+'</span>');
                } else {
                    refElementErrorClass.removeClass('error');
                }
            }
        });

        if (hasError) {
            if (domElementError != null) {
                scrollToEl( domElementError );
            }

            submitBtn.removeAttr('disabled');
            return false;
        }

        //check if EMAIL is a valid value
        var emailInput = form.find('input[name="email"]');
        var emailInputBox = emailInput.closest('.form-group');
        if ( !validateEmail( emailInput.val()) ) {
            emailInputBox.addClass('error');
            if (domElementError == null) {
                domElementError = emailInputBox;
            }
            if (domElementError != null) {
                scrollToEl( domElementError );
            }
            //emailInputBox.find('.col-xs-12').append('<span class="js-error">'+application.tr.email_not_valid+'</span>');

            submitBtn.removeAttr('disabled');
            return false;
        } else {
            emailInputBox.removeClass('error');
        }

        if (hasError) {
            if (domElementError != null) {
                scrollToEl( domElementError );
            }

            submitBtn.removeAttr('disabled');
            return false;
        }

        // remove old success - error messages
        form.find('.bg-success').remove();
        form.find('.bg-error').remove();
        $('#newsletterFormResponse').remove();

        var opts = {
            url: url,
            cache: false,
            method: 'POST',

            processData: false,
            contentType: false,
            //contentType: 'multipart/form-data',
            mimeType: "multipart/form-data",
            data: datasubmit,


            success: function(data){
                if (isOnMessageSet == false) {
                    $(window).on('message', function(evt) {
                        var messageData = evt.originalEvent.data;
                        if (typeof messageData.formGuid != 'undefined') {

                            if (typeof messageData.accepted != 'undefined' && messageData.accepted) {
                                form.prepend('<p class="bg-success" style="padding: 12px 20px;">'+form.attr('data-success')+'</p>');
                                scrollToEl( form.find('p.bg-success') );
                            } else {
                                form.prepend('<p class="bg-error" style="padding: 12px 20px;">'+form.attr('data-error')+'</p>');
                                scrollToEl( form.find('p.bg-error') );
                            }
                        }
                    });
                    isOnMessageSet = true;
                }

                $('body').append( '<div id="newsletterFormResponse">' + data + '</div>' );
            }
        };

        jQuery.ajax(opts)
            .always(function() {
                var submitBtn = form.find('button[type="submit"]');
                submitBtn.removeAttr('disabled');
            });

        return false;
    })

    jQuery.each($('video'), function(){
        if (typeof $(this).attr('data-playbackspeed') != 'undefined') {
            $(this)[0].playbackRate = parseFloat($(this).attr('data-playbackspeed'));
        }
    })


    var initializeMagazineIsotope = function() {
        var magazineIsotopeContainer = $('.magazine-isotope-container');
        if (magazineIsotopeContainer.length == 0) {
            return;
        }

        var options = {
            layoutMode: 'packery',
            packery: {
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer'
            },
            itemSelector: '.grid-item',
            percentPosition: true
        };
        if (magazineIsotopeContainer != '') {
            magazineIsotopeContainer.isotope(options);

            magazineIsotopeContainer.imagesLoaded(function(){
                setTimeout(function(){
                    magazineIsotopeContainer.isotope('layout');
                },300)
            });
        }
    };
    initializeMagazineIsotope();


    /*jQuery.each($('.tokeninput'), function(){
        var form = $(this);
        var url = form.attr('data-tokeninput-action');
        var placeholder = form.find('input[name="q"]').attr('placeholder');
        form.tokenInput(url, {
            minChars: 3,
            hintText: '',
            searchingText: 'Es wird geladen',
            resultsFormatter: function(item){
                return "<li><div class=\"clearfix\"><div class=\"pull-right\">" + item.type_name + "</div>" + item.name + "</div></li>"
            },
            onAdd: function(item){
                window.location.href = item.link;
            }
        });

        form.prev('.token-input-list').find('input').attr('placeholder', placeholder);
    });*/

    jQuery.fn.isOnScreen=function(){var win=$(window);var viewport={top:win.scrollTop(),left:win.scrollLeft()};viewport.right=viewport.left+win.width();viewport.bottom=viewport.top+win.height();var bounds=this.offset();bounds.right=bounds.left+this.outerWidth();bounds.bottom=bounds.top+this.outerHeight();return(!(viewport.right<bounds.left||viewport.left>bounds.right||viewport.bottom<bounds.top||viewport.top>bounds.bottom))};

    if ($('#navbar--percentage').length > 0) {
        $(window).scroll(function(e){
            jQuery.each($('.magazineDetailOuter'),function(){
                if($(this).isOnScreen()){
                    var articleStart=$(this).offset().top;
                    var articleHeight=$(this).height();
                    var scrollTop=$(window).scrollTop();
                    scrollTop-=articleStart;
                    var docHeight=articleHeight;
                    var winHeight=$(window).height();
                    var scrollPercent=(scrollTop)/(docHeight-winHeight);
                    var scrollPercentRounded=Math.round(scrollPercent*100);
                    $('#navbar--percentage').width(scrollPercentRounded+"%");
                }
            })
        });
    }

    // set certification el title same height, so the logos are vertical top aligned
    var setCertificationElTitleSameHeight = function() {
        jQuery.each($('.pimcore_area_certifications '), function(){
            var area = $(this);
            var titles = area.find('.certificationEl .title');
            titles.removeAttr('style');

            var maxHeight = 0;
            jQuery.each(titles, function(){
                var title = $(this);
                if (title.outerHeight() > maxHeight) {
                    maxHeight = title.outerHeight();
                }
            });

            jQuery.each(titles, function(){
                $(this).css('min-height', maxHeight+'px');
            });
        })
    };

    setCertificationElTitleSameHeight();

    $(window).on('load resize', function(){
        setCertificationElTitleSameHeight();
    });

    $('.magazineSubMenuFixed button').click(function(e){
        e.preventDefault();
        $(this).closest('.magazineSubMenuFixed').toggleClass('submenuVisible');
    });

    $('.magazineSubMenuFixed a[data-scroll-to], .magazineSubMenuFixed .closeIcon').click(function(e){
        $(this).closest('.magazineSubMenuFixed').removeClass('submenuVisible');
    });

    $('.js-back').click(function(e){
        e.preventDefault();
        window.history.back();
    });

    if($('#instagram_feed').length > 0) {
        var feedBox = $('#instagram_feed');
        var userId = feedBox.attr('data-user-id');
        var accessToken = feedBox.attr('data-access-token');

        if (typeof userId != 'undefined' && userId != '' && typeof accessToken != 'undefined' && accessToken != '') {
            userId = parseInt(userId);


            var feed = new Instafeed({
                get: 'user',
                userId: userId,
                accessToken: accessToken,
                target: 'instagram_feed',
                resolution: 'standard_resolution',
                after: function() {
                    var maxEl = 15;
                    $('#instagram_feed .loading').remove();
                    var links = $('#instagram_feed >a');
                    /*
                    var removeLast = links.length % 5;
                    for (var i = 0; i<removeLast; i++) {
                        $(links[links.length - 1 - i]).addClass('hidden');
                    }
                    */
                    for (var i = maxEl; i<links.length; i++) {
                        $(links[i]).addClass('hidden');
                    }
                }
            });

            window.onload = function() {
                feed.run();
            };
        }
    }

    $(document).on("click", "#instagram_feed a", function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        window.open(url, '_blank');
    })


});

// if (document.readyState === "complete") {
//     // Fully loaded!
//     initMain(jQuery);
// } else if (document.readyState === "interactive") {
//     // DOM ready! Images, frames, and other subresources are still downloading.
//     initMain(jQuery);
// } else {
//     // Loading still in progress.
//     // To wait for it to complete, add "DOMContentLoaded" or "load" listeners.
//
//     window.addEventListener("DOMContentLoaded", () => {
//         // DOM ready! Images, frames, and other subresources are still downloading.
//         initMain(jQuery);
//     });
//
//     window.addEventListener("load", () => {
//         // Fully loaded!
//     });
// }

export default initMain;
